import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
// 懒加载引入路由
import Layout from "@/views/Layout";
import Home from "@/views/home";
import { h } from "vue"; // 创建标签
const TopCategory = () => import("@/views/category");
const SubCategory = () => import("@/views/category/sub");
const Goods = () => import("@/views/goods/index");
const Login = () => import("@/views/login/index");
const LoginCallback = () => import("@/views/login/callback");
const Cart = () => import("@/views/cart");
const Register = () => import("@/views/login/register");
const PayCheckout = () => import("@/views/member/pay/checkout");
const PayIndex = () => import("@/views/member/pay/index");
const PayResult = () => import("@/views/member/pay/result");
const TradingFloor = () => import("@/views/trading-floor");
const ResourceInfoDetail = () => import("@/views/resource-info-detail");
const PublicAnnouncement = () => import("@/views/public-announcement");
const PublicDetails = () =>
  import(
    "@/views/public-announcement/public-announcement-details/public-announcement-details"
  );
const DataAnalysis = () => import("@/views/data-analysis");
const Search = () => import("@/views/search");
const ServiceCenter = () => import("@/views/service-center");
const PoliciesRegulations = () => import("@/views/policies-regulations");
const ServiceDirectory = () =>
  import("@/views/service-center/components/service-directory.vue");
const DigitalCertificate = () =>
  import("@/views/service-center/components/digital-certificate.vue");
const RentOut = () => import("@/views/home/rent-out.vue");
const RentTenancy = () => import("@/views/home/rent-tenancy.vue");
const LandDemand = () => import("@/views/land-demand");
const LandDemandDetail = () =>
  import("@/views/land-demand/components/detail.vue");

const MemberLayout = () => import("@/views/member/Layout");
const MemberSupply = () => import("@/views/member/supply");
const MemberDemand = () => import("@/views/member/demand");
const MemberSubscribe = () => import("@/views/member/subscribe");
const IntentionToApply = () => import("@/views/member/intention-to-apply");
const MemberBid = () => import("@/views/member/my-bid");
const MemberCollect = () => import("@/views/member/collect");
const MemberMessage = () => import("@/views/member/message");
const MemberContract = () => import("@/views/member/contract");
const MemberContractEdit = () =>
  import("@/views/member/contract/components/edit.vue");
const MemberSettings = () => import("@/views/member/settings");

// 路由规则
// /member开头的都是需要登陆的
const routes = [
  {
    // 一级路由布局容器
    path: "/",
    component: Layout, // 上面导航条和下面footer布局
    children: [
      {
        path: "/",
        component: Home, // 首页
      },
      //自建页面
      {
        path: "/trading-floor", // 交易大厅
        component: TradingFloor,
      },
      {
        path: "/resource-info-detail", //资源信息详情
        component: ResourceInfoDetail,
      },
      {
        path: "/public-announcement", //公示公告
        component: PublicAnnouncement,
      },
      {
        path: "/public-announcement/details", //公告详情
        component: PublicDetails,
        name: "PublicDetails",
      },
      {
        path: "/data-analysis", //数据分析
        component: DataAnalysis,
      },
      {
        path: "/search", //搜索
        component: Search,
      },
      {
        path: "/service-center", //服务中心
        component: ServiceCenter,
      },
      {
        path: "/service-directory", //服务指南
        component: ServiceDirectory,
      },
      {
        path: "/digital-certificate", //数字证书
        component: DigitalCertificate,
      },
      {
        path: "/policies-regulations", //政策法规
        component: PoliciesRegulations,
      },
      {
        path: "/rent-out", //土地出租
        component: RentOut,
      },
      // {
      //   path: "/rent-transfer", //土地转让
      //   component: RentTransfer,
      // },
      {
        path: "/rent-tenancy", //土地求租
        component: RentTenancy,
      },
      // {
      //   path: "/rent-pledge", //土地抵押
      //   component: RentPledge,
      // },
      {
        path: "/land-demand", //地块需求
        component: LandDemand,
      },
      {
        path: "/land-demand-detail", //地块需求详情
        component: LandDemandDetail,
      },
      // end
      {
        path: "/member/checkout", // 需要登陆后才能跳转到的结算页面
        component: PayCheckout,
      },
      { path: "/member/pay", component: PayIndex }, // 支付
      { path: "/pay/callback", component: PayResult }, // 支付结果,后端返回的地址就是/pay/callback
      // 个人中心布局页(他需要 上面导航条布局)
    ],
  },
  // 个人中心
  {
    path: "/member",
    component: MemberLayout, // 个人中心页（左侧菜单布局）
    children: [
      { path: "/member", component: MemberSupply }, // 我的供应
      { path: "/member/demand", component: MemberDemand }, // 我的需求
      { path: "/member/subscribe", component: MemberSubscribe }, // 我的申购
      { path: "/member/intentionToApply", component: IntentionToApply }, // 我的申购
      { path: "/member/bid", component: MemberBid }, // 我的竞买
      { path: "/member/collect", component: MemberCollect }, // 我的收藏
      { path: "/member/message", component: MemberMessage }, // 我的消息
      { path: "/member/contract", component: MemberContract }, // 我的合同
      { path: "/member/contract/edit", component: MemberContractEdit }, // 我的合同编辑
      { path: "/member/settings", component: MemberSettings }, // 账户设置
    ],
  },
  // 登录页
  {
    path: "/login",
    component: Login,
  },
  // qq登陆后回跳的页
  {
    path: "/login/callback",
    component: LoginCallback,
  },
  // 注册页
  {
    path: "/register",
    component: Register,
  },
];
// vue2.0 new VueRouter()创建路由实例
// vue3.0 createRouter()创建路由实例

const router = createRouter({
  history: createWebHashHistory(), // 使用hash路由模式
  routes,
  scrollBehavior() {
    // 每次切换路由时，页面滚动的位置
    // return { x: 0, y: 0 }// vue2.0顶部
    return { left: 0, top: 0 }; // vue3.0顶部
  },
});

// 前置路由守卫
// js模块中：router.currentRoute.value.fullPath 就是当前路由地址
// '/user?a=10'  path: /user ,fullPath : user?a=10

// 1、to:即将要进入的目标路由对象；
// 2、from:当前导航即将要离开的路由对象；
// 3、next ：调用该方法后，才能进入下一个钩子函数（afterEach）。
router.beforeEach((to, from, next) => {
  // 约定： 需要登陆后才能跳转的地址 都是以/member开头的
  // 判断 如果用户没登录&&跳转的地址开头为/member
  // 就先跳转到登录页，然后重定向到你要去的地址
  const { profile } = store.state.user;
  if (!profile.token && to.path.startsWith("/member")) {
    return next("/login?redirectUrl=" + encodeURIComponent(to.fullPath));
  }
  // 剩下放行
  next();
});

export default router;
